import styles from './ErrorMessage.module.scss';

interface ErrorMessageI {
  message: string;
  marginTop?: string | number;
}

export default function ErrorMessage({ message, marginTop }: ErrorMessageI) {
  return (
    <p className={styles.errorMessageStyles} style={{ marginTop: marginTop }}>
      {message}
    </p>
  );
}
